// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c6zb","col":"styles_col__3R7Rd"};